import React from 'react'
import { observer } from 'mobx-react-lite'
import Picker, { type IEmojiData } from 'emoji-picker-react'
import { Dropdown, IconButton, Tooltip, type IIconButtonColor } from 'shared/ui'
import type { ZIndex } from 'shared/constants/zIndex'
import { type MessageFieldStore } from 'widgets/MessageField'
import styles from './styles.module.scss'

type IEmojiPickerProps = {
  onTrigger?: () => void
  iconColor?: IIconButtonColor
  messageFieldStore: MessageFieldStore
  zIndex?: ZIndex
}

export const EmojiPicker: React.FC<IEmojiPickerProps> = observer(
  ({ onTrigger, iconColor = 'secondary', messageFieldStore, zIndex }) => {
    const { addContent, isModeNote } = messageFieldStore
    const handleEmojiClick =
      (onCloseMenu: () => void) => (event: React.MouseEvent, emojiObject: IEmojiData) => {
        onCloseMenu()
        addContent && addContent(emojiObject.emoji)
      }

    const handleTooltipOpen = () => {
      onTrigger && onTrigger()
    }

    return (
      <>
        <Dropdown
          ariaLabel={'EmojiPicker'}
          placement={'bottom'}
          typeButton={'icon-button'}
          zIndex={zIndex}
          triggerComponent={(open) => (
            <div>
              <Tooltip label={open ? '' : 'Add emoji'} title={''} placement={'top'} zIndex={zIndex}>
                <IconButton
                  icon={'emoji'}
                  variant={isModeNote ? 'contained' : 'icon'}
                  color={isModeNote ? 'passiveSecondary' : iconColor}
                  onClick={handleTooltipOpen}
                  active={open}
                  ariaLabel='EmojiPicker'
                />
              </Tooltip>
            </div>
          )}
          customComponent={(onCloseMenu) => (
            <div className={styles.emoji}>
              <Picker onEmojiClick={handleEmojiClick(onCloseMenu)} />
            </div>
          )}
        />
      </>
    )
  }
)
